import { render, staticRenderFns } from "./KMenuWithoutChildren.vue?vue&type=template&id=1f17e1bf"
import script from "./KMenuWithoutChildren.vue?vue&type=script&lang=js"
export * from "./KMenuWithoutChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports